function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: IMPORTARRAY opcode — verify a signed witness array and store it
 * under `key` in context.__opcodes.importarray.
 *
 * Language shape (KEY / VALUE):
 *   script.key           — variable name to create
 *   witness.value        — imported array
 *   witness.signature    — authorizes that array
 *   script.hash          — contextual binding (same as IMPORTFIELD)
 *
 * digest = HASH(canonical_json(value) | binding_hash)
 */

module.exports = {
  name: 'IMPORTARRAY',
  description: "\nImports a signed array into VARS under a named key.\n\nVerifies that witness.value (an array) was signed by an authorized publickey\nover a binding hash (literal or VAR reference), then writes the array into\ncontext.__opcodes.importarray[key].\n\nTypical use:\n- import successor payment schedules\n- import allow-lists, hop sets, etc.\n",
  exampleScript: {
    op: 'IMPORTARRAY',
    key: 'successors',
    publickey: '__opcodes.checkownnftwhere.creator',
    hash: '__opcodes.checkownnftwhere.nft_id',
    witness: {
      value: [{
        public_key: '<publickey>',
        amount: 100
      }, {
        public_key: '<publickey>',
        amount: 50
      }],
      signature: '<hex_signature>'
    }
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    if (!context.app || !context.app.crypto || typeof context.app.crypto.hash !== 'function' || typeof context.app.crypto.verifyMessage !== 'function') {
      return false;
    }
    var key = node.key;
    if (typeof key !== 'string' || key.length === 0) {
      return false;
    }
    var witness = node.witness;
    if (!witness || _typeof(witness) !== 'object' || Array.isArray(witness)) {
      return false;
    }
    var signer_pubkey = node.publickey;
    if (typeof signer_pubkey === 'string') {
      signer_pubkey = resolveRef(context, signer_pubkey);
    }
    var binding_hash = node.hash;
    if (typeof binding_hash === 'string') {
      binding_hash = resolveRef(context, binding_hash);
    }
    if (typeof signer_pubkey !== 'string' || signer_pubkey.length === 0) {
      return false;
    }
    if (typeof binding_hash !== 'string' || binding_hash.length === 0) {
      return false;
    }
    var value = witness.value;
    if (typeof value === 'string') {
      value = resolveRef(context, value);
    }
    var signature = witness.signature;
    if (typeof signature === 'string') {
      signature = resolveRef(context, signature);
    }
    if (!Array.isArray(value)) {
      return false;
    }
    if (typeof signature !== 'string' || signature.length === 0) {
      return false;
    }
    var canonical_string = canonicalJson(value) + '|' + binding_hash;
    var digest = context.app.crypto.hash(canonical_string);
    if (context.app.crypto.verifyMessage(digest, signature, signer_pubkey) !== true) {
      return false;
    }
    if (!context.__opcodes) {
      context.__opcodes = {};
    }
    if (!context.__opcodes.importarray) {
      context.__opcodes.importarray = {};
    }
    context.__opcodes.importarray[key] = value;
    return true;
  }
};

/** Match Rust `canonical_json`: sorted object keys, stable array order. */
function canonicalJson(value) {
  if (value === null) {
    return 'null';
  }
  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }
  if (typeof value === 'number') {
    return JSON.stringify(value);
  }
  if (typeof value === 'string') {
    return JSON.stringify(value);
  }
  if (Array.isArray(value)) {
    return '[' + value.map(canonicalJson).join(',') + ']';
  }
  if (value && _typeof(value) === 'object') {
    var keys = Object.keys(value).sort();
    return '{' + keys.map(function (k) {
      return JSON.stringify(k) + ':' + canonicalJson(value[k]);
    }).join(',') + '}';
  }
  return 'null';
}
function resolveRef(root, ref) {
  if (typeof ref !== 'string') {
    return ref;
  }
  var parts = ref.split('.');
  var cursor = root;
  for (var i = 0; i < parts.length; i += 1) {
    var key = parts[i];
    if (!cursor || _typeof(cursor) !== 'object' || !Object.prototype.hasOwnProperty.call(cursor, key)) {
      return ref;
    }
    cursor = cursor[key];
  }
  return cursor;
}